import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BookDto } from './book.model';

export const BookActions = createActionGroup({
  source: 'Book API',
  events: {
    'Get Book': emptyProps(),
    'Get Book Success': props<{ book: BookDto }>(),
    'Get Book Failure': props<{ error: Error }>(),
  },
});
